Pixlee.module('GridsApp.Grid', function(Grid, App, Backbone, Marionette, $) {

    var _this = this,
        API;
    Grid.Controller = App.Controllers.Application.extend({
        initialize: function(options) {
            var _this = this;
            this.collectionView = this.getGridView();
            this.GridLayout = this.getGridLayout();
            this.gridSettings = this.getGridSettings();
            this.listenTo(this.GridLayout, 'show', this.onLayoutShow);
            _this.show(_this.GridLayout, {
                region: App.widgetsRegion
            });
            var onCollectionrRenderDebounce = _.debounce(this.onRender, 100);
            this.collectionView.on('added:image', onCollectionrRenderDebounce, this);
            this.on('image:added', this.addedImage, this);
            this.on('image:removed', this.removeImage, this);
            this.on('changed:image', this.changedImage, this);
            this.on('changed:animation', this.changedAnimation, this);
            this.on('changed:pin:url', this.changedPinURL, this);
        },
        getGridSettings: function() {
            return new Grid.Selector();
        },
        getGridView: function() {
            var _this = this;
            this.photoscollection = App.request('get:photos:widget:photowall');
            this.referenceCollection = _.clone(this.photoscollection);
            return new Grid.View({
                collection: _this.photoscollection,
                referenceCollection: _this.referenceCollection
            });
        },
        addedImage: function(data) {
            var model = App.request('get:new:photo');
            model.attributes = data;
            gon.restricted_images = _.without(gon.restricted_images, model.attributes.id);
            gon.fresh_images.unshift(model);
        },
        removeImage: function(data) {

            var model = App.request('get:new:photo');
            model.attributes = data;
            var goodList = [];
            _.each(gon.fresh_images, function(element, index, list) {
                if (element.id != data.id)
                    goodList.unshift(element);
            });
            gon.fresh_images = goodList;
            gon.restricted_images.unshift(model.attributes.id);
            this.collectionView.trigger('remove:image', model);

        },
        changedImage: function() {
            this.collectionView.trigger('changed:image');
        },
        changedAnimation: function() {
            this.collectionView.trigger('changed:animation');
            this.grid.init();
        },
        changedPinURL: function() {
            this.gridSettings.trigger('changed:pin:url');
        },
        onLayoutShow: function() {
            this.show(this.gridSettings, {
                region: this.GridLayout.selector_region
            });
            this.show(this.collectionView, {
                region: this.GridLayout.photos_region
            });
        },
        getGridLayout: function(options) {
            var config;
            var _this = this;
            if (options == null) {
                options = {};
            }
            return new Grid.Layout();
        },
        onRender: function() {
            var _this = this;
            this.gridSelector = new GridSelctor();
            this.grid = new Grids();
            this.grid.init({
                transition: true
            });


            $('#grid_footer, #grid_settings_wrapper').show();
            $('#grid_settings_wrapper').hover(function() {
                $('#grid_settings_container').fadeToggle('fast');
            });
            $(this.collectionView.$el).height($(window).height() - 105);
            $(this.collectionView.$el).width($(window).width());
            $('#grid_bottom_text').find('textarea').val(gon.grid_params.action_text);

            $('#hashtag_text').html(gon.grid_params.action_text);
            var longText;
            if ($('#hashtag_holder')[0].scrollWidth > $('#hashtag_holder').innerWidth()) {
                longText = true;
            } else {
                longText = false;
            }
            gon.marquee = $('#hashtag_holder').marquee({
                duration: 10000
            }); //iniatilize first and destroy/keep. This is for marquee init bug
            $('#grid_transition_animation option[value=' + gon.grid_params.animation + ']').prop('selected', true);
            $('#grid_interval_speed option[value=' + gon.grid_params.interval + ']').prop('selected', true);
            $('#grid_offline_mode option[value=' + gon.grid_params.offlineMode + ']').prop('selected', true);
            if (!longText) {
                $('.js-marquee').css('float', '');
                gon.marquee.marquee('destroy');
                gon.marquee = null;
                $('#hashtag_text').html(gon.grid_params.action_text);
            }
            $('#grid_url_link_text').text(window.location.origin + window.location.pathname);
            if ($('#pixlee_logo').length == 0) {
                $('#hashtag_text').css('top', '0px');
            }
            $('#row_param').text(gon.grid_params.row);
            $('#column_param').text(gon.grid_params.column);
            $('#interval_param').text(gon.grid_params.interval);
            $('#animation_param').text(gon.grid_params.animation);
            $('#offline_mode_param').text(gon.grid_params.offlineMode);
            $('#action_text_param').text(encodeURIComponent(gon.grid_params.action_text));
            if (gon.defaultSetting) {
                $('[data-column="5"][data-row="3"]').click();
            }
            $('#pinned_param').text(btoa(JSON.stringify(gon.grid_params.pinned)));

            this.collectionView.trigger('set:pins');

            setTimeout(function() {
                _this.collectionView.trigger('done');
            }, 3000);

        }
    });
});